import React from "react";

//
import { Row, Col } from "react-bootstrap";

//
import UserInfo from "../../../components/account/profile/UserInfo";
import SocialAccounts from "../../../components/account/profile/SocialAccounts";
import DeleteAccount from "../../../components/account/profile/DeleteAccount";
import EmailVerify from "../../../components/account/profile/EmailVerify";

function Profile() {
  return (
    <div className="profile">
      <Row>
        <UserInfo />
        <Col md={5} xl={4} className="gutter-b">
          <SocialAccounts />
        </Col>
      </Row>

      <EmailVerify />

      <DeleteAccount />
    </div>
  );
}

export default Profile;
